import { extractFormatterType } from '@keen.io/charts-utils';
export var sortData = function (data, sortBy, formatValue) {
    var sort = sortBy.sort, property = sortBy.property;
    var formatPattern = formatValue && formatValue[property];
    var formatterType = formatPattern &&
        typeof formatPattern === 'string' &&
        extractFormatterType(formatPattern);
    var isNumeric = formatterType === 'number' ||
        (data[0][property] !== null &&
            !isNaN(data[0][property]) &&
            formatterType !== 'string');
    if (isNumeric) {
        return data.sort(function (a, b) {
            if (sort === 'ascending') {
                return a[property] - b[property];
            }
            else {
                return b[property] - a[property];
            }
        });
    }
    return data.sort(function (a, b) {
        var aString = a[property] ? a[property].toString() : '';
        var bString = b[property] ? b[property].toString() : '';
        if (sort === 'ascending') {
            return aString.localeCompare(bString, undefined, { caseFirst: 'lower' });
        }
        else {
            return bString.localeCompare(aString, undefined, { caseFirst: 'upper' });
        }
    });
};
